module.exports = __webpack_public_path__ + "img/silver11.14008a26.gif";